import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import * as fromDepartment from './department/department.reducer';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('department', fromDepartment.reducer)],
})
export class SharedDepartmentDataAccessModule {}
